"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Avatar_1 = __importDefault(require("../../Avatar"));
var Contacts = function (_a) {
    var post = _a.post;
    var _b = post.contacts, contacts = _b === void 0 ? [] : _b, _c = post.owner, owner = _c === void 0 ? { name: '', image: '' } : _c;
    var contactNumbers = [];
    var getPhoneLink = function (contactNumber) {
        if (contactNumber.type === 'viber') {
            return "viber://chat?number=" + contactNumber.number;
        }
        if (contactNumber.type === 'whatsapp') {
            return "https://wa.me/" + contactNumber.number;
        }
        return "tel:" + contactNumber.number;
    };
    var getPhoneIcon = function (contactNumber) {
        if (contactNumber.type === 'viber') {
            return "icon-ic-viber";
        }
        if (contactNumber.type === 'whatsapp') {
            return "icon-ic-whatsapp";
        }
        return "icon-phone";
    };
    contacts.forEach(function (contact) {
        var _a = contact.messengers, messengers = _a === void 0 ? [] : _a;
        contactNumbers.push({ number: contact.phone });
        messengers.forEach(function (messenger) {
            return contactNumbers.push({
                number: contact.phone,
                type: messenger,
            });
        });
    });
    return (react_1.default.createElement("div", { className: "contact-info" },
        react_1.default.createElement("div", { className: "owner-thumb" },
            react_1.default.createElement(Avatar_1.default, { img: owner.image, name: owner.name })),
        react_1.default.createElement("div", { className: "owner-info" },
            react_1.default.createElement("span", { className: "title" }, owner.name),
            react_1.default.createElement("div", { className: "phone-numbers-cont" },
                react_1.default.createElement("ul", null, contactNumbers.map(function (contactNumber, index) {
                    return (react_1.default.createElement("li", { className: "", key: index },
                        react_1.default.createElement("i", { className: getPhoneIcon(contactNumber) }),
                        react_1.default.createElement("a", { href: getPhoneLink(contactNumber), onClick: function (e) {
                                e.stopPropagation();
                            } }, contactNumber.number)));
                }))))));
};
exports.default = Contacts;
